import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { AssignmentParticipantsAttendancesUpdatePostModel } from '../models/assignment-participants-attendances/assignment-participants-attendances-update-post.model';
import { AssignmentParticipantsAttendancesModel } from '../models/assignment-participants-attendances/assignment-participants-attendances.model';

@Injectable({
    providedIn: 'root'
})
export class AssignmentParticipantsAttendanceService {

    constructor(private httpClient: HttpClient) { }

    getIsCheckAllowed(assignmentId: number): Observable<boolean> {
        return this.httpClient.get<boolean>(`${environment.api}/assignments/${assignmentId}/participants/attendances/isCheckAllowed`);
    }

    getAssignmentParticipantsAttendances(assignmentId: number): Observable<AssignmentParticipantsAttendancesModel[]> {
        return this.httpClient.get<AssignmentParticipantsAttendancesModel[]>(`${environment.api}/assignments/${assignmentId}/participants/attendances`);
    }

    updateAssignmentParticipantsAttendances(assignmentId: number, participantsAttendances: AssignmentParticipantsAttendancesUpdatePostModel[]): Observable<void> {
        return this.httpClient.post<void>(`${environment.api}/assignments/${assignmentId}/participants/attendances`, participantsAttendances);
    }
}
